import React, { createContext, useState } from 'react';
import { v4 as uuid } from 'uuid';
import { TypeOf } from 'yup';

const fromBackendOportunidades = [];
const cards = {
  [uuid()]: {
    name: 'Novas Oportunidades',
    color: '#001E64',
    items: fromBackendOportunidades,
    id: 1,
    status: 'Oportunidades'
  },
  [uuid()]: {
    name: 'Fazer novo contato',
    color: '#001E64',
    items: [],
    id: 2,
    status: 'NovoContato'
  },
  [uuid()]: {
    name: 'Em negociação',
    color: '#001E64',
    items: [],
    id: 3,
    status: 'EmNegociacao'
  },
  [uuid()]: {
    name: 'Concluído',
    color: '#001E64',
    items: [],
    id: 4,
    status: 'Concluido'
  }
};

type Headers = {
  cpf: string | null;
  cnpj: string | null;
  login?: string | null;
};
type Query = {
  status: string | null;
  'data-inicial': string | null;
  'data-final': string | null;
  campanha: string | null;
  'abordagem-n2': string | null;
  produto: string | null;
  'produto-atual': string | null;
  abordagem: string | null;
  nome: string | null;
  email: string | null;
  telefone: string | null;
  celular: string | null;
};

export type FiltersType = {
  query: Query | null;
  headers: Headers | null;
};
const filters: FiltersType = {
  query: {
    status: '',
    'data-inicial': '',
    'data-final': '',
    campanha: '',
    'produto-atual': '',
    'abordagem-n2': '',
    produto: '',
    abordagem: '',
    nome: '',
    email: '',
    telefone: '',
    celular: ''
  },
  headers: {
    cpf: '',
    cnpj: ''
  }
};
type Order = {
  ordenacao: string | null;
  direcao: string | null;
};
const ordenacao: Order = {
  ordenacao: '',
  direcao: ''
};
type FiltersStateProps = {
  campaigns: string[];
  text: string;
};

type FilterContextProps = {
  currentPageOportunidades: number;
  setCurrentPageOportunidades: React.Dispatch<React.SetStateAction<number>>;

  currentPageNovoContato: number;
  setCurrentPageNovoContato: React.Dispatch<React.SetStateAction<number>>;

  currentPageEmNegociacao: number;
  setCurrentPageEmNegociacao: React.Dispatch<React.SetStateAction<number>>;

  currentPageConcluido: number;
  setCurrentPageConcluido: React.Dispatch<React.SetStateAction<number>>;

  leads: typeof cards;
  setLeads: React.Dispatch<React.SetStateAction<typeof cards>>;

  filterObject: FiltersType;
  setFilterObject: React.Dispatch<React.SetStateAction<FiltersType>>;

  orderBy: Order;
  setOrderBy: React.Dispatch<React.SetStateAction<Order>>;

  exportObject: FiltersType;
  setExportObject: React.Dispatch<React.SetStateAction<FiltersType>>;

  filterTextState: string;
  setFilterTextState: React.Dispatch<React.SetStateAction<string>>;

  filterSelectState: string[];
  setFilterSelectState: React.Dispatch<React.SetStateAction<string[]>>;

  filtersState: FiltersStateProps;

  setFiltersState: React.Dispatch<React.SetStateAction<FiltersStateProps>>;

  loadingFilters: boolean;
  setLoadingFilters: React.Dispatch<React.SetStateAction<boolean>>;
};

const initialValues = {
  currentPageOportunidades: 1,

  setCurrentPageOportunidades: () => {
    0;
  },

  currentPageNovoContato: 1,

  setCurrentPageNovoContato: () => {
    0;
  },

  currentPageEmNegociacao: 1,

  setCurrentPageEmNegociacao: () => {
    0;
  },

  currentPageConcluido: 1,

  setCurrentPageConcluido: () => {
    0;
  },

  leads: cards,

  setLeads: () => {
    ('');
  },

  filterObject: filters,

  setFilterObject: () => {
    ('');
  },

  orderBy: ordenacao,

  setOrderBy: () => {
    ('');
  },

  exportObject: filters,

  setExportObject: () => {
    ('');
  },

  filterTextState: '',

  setFilterTextState: () => {
    ('');
  },

  filterSelectState: [''],

  setFilterSelectState: () => {
    ('');
  },
  filtersState: {
    campaigns: [],
    text: ''
  },
  setFiltersState: () => {
    [];
  },
  loadingFilters: false,
  setLoadingFilters: () => {
    ('');
  }
};

const FilterContext = createContext<FilterContextProps>(initialValues);

const FilterContextProvider: React.FC = ({ children }) => {
  const [currentPageOportunidades, setCurrentPageOportunidades] = useState(
    initialValues.currentPageOportunidades
  );
  const [currentPageNovoContato, setCurrentPageNovoContato] = useState(
    initialValues.currentPageNovoContato
  );
  const [currentPageEmNegociacao, setCurrentPageEmNegociacao] = useState(
    initialValues.currentPageEmNegociacao
  );
  const [currentPageConcluido, setCurrentPageConcluido] = useState(
    initialValues.currentPageConcluido
  );

  const [leads, setLeads] = useState(initialValues.leads);

  const [filterObject, setFilterObject] = useState<FiltersType>(
    initialValues.filterObject
  );

  const [orderBy, setOrderBy] = useState<Order>(initialValues.orderBy);

  const [exportObject, setExportObject] = useState<FiltersType>(
    initialValues.exportObject
  );

  const [filterTextState, setFilterTextState] = useState(
    initialValues.filterTextState
  );

  const [filterSelectState, setFilterSelectState] = useState(
    initialValues.filterSelectState
  );
  const [loadingFilters, setLoadingFilters] = useState(
    initialValues.loadingFilters
  );

  const [filtersState, setFiltersState] = useState(initialValues.filtersState);

  return (
    <FilterContext.Provider
      value={{
        currentPageOportunidades,
        setCurrentPageOportunidades,
        currentPageNovoContato,
        setCurrentPageNovoContato,
        currentPageEmNegociacao,
        setCurrentPageEmNegociacao,
        currentPageConcluido,
        setCurrentPageConcluido,
        filterObject,
        setFilterObject,
        exportObject,
        setExportObject,
        leads,
        setLeads,
        filterTextState,
        setFilterTextState,
        filterSelectState,
        setFilterSelectState,
        filtersState,
        setFiltersState,
        loadingFilters,
        setLoadingFilters,
        orderBy,
        setOrderBy
      }}
    >
      {children}
    </FilterContext.Provider>
  );
};
export { FilterContextProvider };
export default FilterContext;
